export const defaultRegistryUrl = 'https://search.devbox.sh/v2/';

export const datasource = 'devbox';
